module.exports = __webpack_public_path__ + "static/media/1001208MF.05f8924c.jpg";